// @ts-check
import { useContext, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import useSelectedFilterSet from '../../../../../hooks/useSelectedFilterSet';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import useContextActions from '../../../../../useContextActions';
import { LBButton } from '@linearb/buzz';

const StyledSaveFiltersButton = styled.div`
  margin-left: auto;
  padding-left: 4rem;
  padding-top: 0.5rem;
`;

const SaveFiltersButton = ({ Context }) => {
  const {
    state: { localFilters }
  } = useContext(Context);
  const contextActions = useContextActions({ Context });
  const selectedFilterSet = useSelectedFilterSet(Context);

  const [isLoading, setIsLoading] = useState(false);
  const isDisabled =
    isEqual(selectedFilterSet.filters, localFilters) || isLoading;

  const onSave = async e => {
    e.stopPropagation();
    setIsLoading(true);
    await contextActions.onUpdateFilterSet(selectedFilterSet.id, {
      filters: localFilters
    });
    setIsLoading(false);
  };

  return (
    <StyledSaveFiltersButton>
      <LBButton disabled={isDisabled} size='sm' onClick={onSave}>
        {isLoading ? <CircularProgress size={13} /> : 'Save'}
      </LBButton>
    </StyledSaveFiltersButton>
  );
};

export default SaveFiltersButton;
